import { WorkAPI } from "../../../axios/api";
import moment from "moment";

export const checkValValid = ({ warn_limit, field, val }) => {
  return val < warn_limit[field].down || val > warn_limit[field].up;
};

export const rateHandler = async ({
  memberid,
  my_old_day_data,
  my_todays_data,
  old_date,
  now_date,
} = {}) => {
  if (old_date) old_date = moment(old_date).format("YYYY-MM-DD");
  now_date = moment(now_date).format("YYYY-MM-DD");

  // 取得每日個人目標
  let result_goal = await WorkAPI.getPersonalGoalsDatasByMemberid({
    data: {
      memberid,
    },
  });
  result_goal = Object.values(result_goal.data);

  if (my_old_day_data)
    await formatRate({
      memberid,
      goalData: result_goal,
      date: old_date,
      dateData: my_old_day_data,
    });
  await formatRate({
    memberid,
    goalData: result_goal,
    date: now_date,
    dateData: my_todays_data,
  });
};

const formatRate = async ({ memberid, goalData, date, dateData }) => {
  let dayIndex = new Date(date).getDay(); // 日期是週幾
  if (dayIndex === 0) dayIndex = 7; // 0 是 禮拜天

  let goalCount = goalData.reduce(
    (pre, cur) => (pre += cur[`day${dayIndex}`]),
    0
  ); // 目標應有的資料筆數
  if (goalCount === 0) return;

  let keys = {
    record_heartbeat_blood_pressure: 0,
    record_glucose: 1,
    record_weight: 2,
    record_uncomfortable_symptoms: 3,
    record_health_behavior: 4,
  };
  let exist_count = Object.entries(dateData).filter(
    ([key, val]) => val && goalData[keys[key]][`day${dayIndex}`] === 1
  ).length; // 目前存在的資料筆數

  // 取執行率資料
  let { Response, data } = await WorkAPI.getDoRateListByMemberid({
    data: { memberid, page: -1, startDate: date, endDate: date },
  });
  if (Response === 1) {
    let rate = (exist_count / goalCount) * 100, // 執行率
      point = rate === 100 ? 1 : 0, // 點數
      getpointdatetime = rate === 100 ? moment().format("YYYY-MM-DD") : null; // 獲得點數(皇冠)時間

    if (data.length > 0) {
      // 更新
      await WorkAPI.updateDoRate({
        data: {
          id: data[0].today_record.doRatesRecords.id,
          getpointdatetime,
          point,
          rate,
        },
      });
    } else {
      // 新增
      await WorkAPI.setDoRate({
        data: {
          memberid,
          date: date,
          getpointdatetime,
          point,
          rate,
        },
      });
    }
  }
};
